<template>
  <el-dialog
    :visible.sync="dialogAddVisible"
    width="30%"
    :title="(editData ? '编辑' : '新建') + '角色'"
    center
    @close="resetForm"
  >
    <el-form
      :model="form"
      label-width="100px"
      ref="addFormRef"
      :rules="addRules"
    >
      <!-- 新增客服角色请以5开头的数字进行编码 -->
      <el-form-item label="编码" prop="roleCode">
        <el-input
          v-model="form.roleCode"
          clearable
          :disabled="editData"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="roleName">
        <el-input v-model="form.roleName" clearable></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input v-model="form.description" clearable></el-input>
      </el-form-item>
      <el-form-item label="注册可选项" prop="registerOption">
        <el-radio-group v-model="form.registerOption">
          <el-radio :label="0">不提供选择</el-radio>
          <el-radio :label="1">可以选择</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogAddVisible = false;
          resetForm();
        "
        >取消</el-button
      >
      <el-button type="primary" @click="submitEdit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addRoleApi, editRoleApi } from '@/api/user.js';
export default {
  props: ['editData'],
  data() {
    return {
      dialogAddVisible: false,
      form: {
        roleCode: '',
        roleName: '',
        roleType: '',
        bonusRate: '',
        description: '',
        registerOption: 0,
      },
      addRules: {
        roleCode: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        roleName: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        roleType: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        bonusRate: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        registerOption: [
          { required: true, message: '该值是必填的', trigger: 'blur' },
        ],
        areaId: '',
      },
    };
  },
  inject: ['reload'],
  created() {
    this.areaId = localStorage.getItem('areaId')
      ? JSON.parse(localStorage.getItem('areaId')).areaId
      : '';
  },
  methods: {
    resetForm() {
      this.form = {};
      this.$refs.addFormRef.resetFields();
    },
    submitEdit() {
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          if (this.editData) {
            this.handleEdit();
          } else {
            this.handleAdd();
          }
        } else {
          this.$message.error('请仔细检查格式！');
        }
      });
    },
    // 添加角色
    async handleAdd() {
      const data = { ...this.form, areaId: this.areaId };
      const res = await addRoleApi(data);
      if (res.code == 200) {
        this.$message.success('新增成功');
        this.reload();
      }
    },
    // 编辑角色
    async handleEdit() {
      const data = { ...this.form, areaId: this.areaId };
      const res = await editRoleApi(data);
      if (res.code == 200) {
        this.$message.success('编辑成功');
        this.reload();
      }
    },
  },
};
</script>
